import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoCompareProduct from 'eco-design/sections/eco-compare-product';
import { useProductStore } from '../../../../ProductProvider';
import { IPageStatus } from '../../../../config/IPageStatus';
import styles from './index.module.scss';

const productIdObj = {
    jp: 51919145959791,
};

export default function Comp() {
    const { t } = useLang('theProduct');
    const { locale = 'us' } = getLocal();
    const { pageStatus } = useProductStore();

    const IS_EU_SITE = ['eu', 'uk', 'de', 'fr', 'es', 'it'].includes(locale);
    const IS_NA_SITE = ['us', 'ca'].includes(locale);
    const IS_JP_SITE = ['jp'].includes(locale);
    const IS_AU_SITE = ['au'].includes(locale);
    const itemsA = [
        {
            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1744878697753/WAVE%203.png',
                    label: t('N_tag'),
                    title: t('N_p1'),
                    lChildren: IS_JP_SITE ? t('N_btn_detail') : '',
                    lBtnClick() {
                        window.open(`https://jp.ecoflow.com/products/wave-3-portable-air-conditioner`, '_blank');
                    },
                    rType: 'outlined',
                    rRadius: 'ellipse',
                    rIsWithRightArrow: false,
                    rChildren:
                        (IS_EU_SITE && pageStatus === IPageStatus.statusB) || IS_JP_SITE || (IS_AU_SITE && pageStatus === IPageStatus.statusB)
                            ? t('N_lbtn')
                            : '',
                    rBtnClick() {
                        if (IS_JP_SITE) {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'checkout',
                                button_name: `${t('N_lbtn')}_${t('N_p1')}`,
                            });
                            window.open(`https://jp.ecoflow.com/cart/${productIdObj.jp}:1?channel=buy_button`, '_blank');
                        } else if (IS_EU_SITE) {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: t('N_p1'),
                                position: `Product Detail_${t('N_title')}`,
                            });
                            window.open(`https://${locale}.ecoflow.com/products/wave-3-portable-air-conditioner`);
                        } else if (IS_AU_SITE) {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: t('N_p1'),
                                position: `Product Detail_${t('N_title')}`,
                            });
                            window.open(`https://au.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner`);
                        }
                    },
                    specItems: [
                        {
                            title: t('N_p1_c1'),
                            desc: t('N_porp1'),
                        },
                        {
                            title: t('N_p1_c2'),
                            desc: t('N_porp2'),
                        },
                        {
                            title: t('N_p1_c3'),
                            desc: t('N_porp3'),
                        },
                        {
                            title: t('N_p1_c4'),
                            desc: t('N_porp4'),
                        },
                        {
                            title: t('N_p1_c5'),
                            desc: t('N_porp5'),
                        },
                        {
                            title: t('N_p1_c6'),
                            desc: t('N_porp6'),
                        },
                        {
                            title: t('N_p1_c7'),
                            desc: t('N_porp7'),
                        },
                        {
                            title: t('N_p1_c8'),
                            desc: t('N_porp8'),
                        },
                        (IS_JP_SITE || IS_EU_SITE) && {
                            title: t('N_p1_c9'),
                            desc: t('N_porp9'),
                        },
                    ].filter(Boolean),
                },
            ],
        },
        {
            subItems: [
                {
                    pc:
                        locale === 'us'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1744878697399/WAVE%202.png'
                            : 'https://websiteoss.ecoflow.com/upload/image/1744878697573/WAVE%202ss.png',
                    title: t('N_p2'),
                    tag: ' ',
                    specItems: [
                        {
                            title: t('N_p2_c1'),
                            desc: t('N_porp1'),
                        },
                        {
                            title: t('N_p2_c2'),
                            desc: t('N_porp2'),
                        },
                        {
                            title: t('N_p2_c3'),
                            desc: t('N_porp3'),
                        },
                        {
                            title: t('N_p2_c4'),
                            desc: t('N_porp4'),
                        },
                        {
                            title: t('N_p2_c5'),
                            desc: t('N_porp5'),
                        },
                        {
                            title: t('N_p2_c6'),
                            desc: t('N_porp6'),
                        },
                        {
                            title: t('N_p2_c7'),
                            desc: t('N_porp7'),
                        },
                        {
                            title: t('N_p2_c8'),
                            desc: t('N_porp8'),
                        },
                        (IS_JP_SITE || IS_EU_SITE) && {
                            title: t('N_p2_c9'),
                            desc: t('N_porp9'),
                        },
                    ].filter(Boolean),
                },
            ],
        },
    ];
    return (
        <div className={styles.comp} id="CompareA">
            <EcoSpace />
            <EcoSectionCommon title={t('N_title')} />
            <EcoSpaceSmall />
            <EcoCompareProduct items={itemsA} />
        </div>
    );
}
